import { semantic } from './theme';

/** Consistent outline stroke for Lucide icons */
export const APP_ICON_STROKE = 1.5;

/**
 * Single style for outline icons: neutral by default, brand when active (light surfaces).
 * Use tone="inverse" for active items on dark fills (e.g. platform nav).
 */
export function AppIcon({
  Icon,
  size = 18,
  active = false,
  tone = 'muted',
  color: colorProp,
  strokeWidth = APP_ICON_STROKE,
  style,
  ...rest
}) {
  let color = colorProp;
  if (color == null) {
    if (tone === 'inverse' || tone === 'onBrand') {
      color = semantic.fg.inverse;
    } else if (tone === 'danger') {
      color = semantic.status.danger;
    } else if (active || tone === 'brand') {
      color = semantic.brand.primary;
    } else if (tone === 'default') {
      color = semantic.fg.default;
    } else {
      color = semantic.fg.icon;
    }
  }

  return (
    <Icon
      size={size}
      strokeWidth={strokeWidth}
      color={color}
      aria-hidden
      style={{ flexShrink: 0, display: 'block', ...style }}
      {...rest}
    />
  );
}
